module.exports = __webpack_public_path__ + "img/GALLERY-FRONX-BOOSTERGREEN-3.e156d62f.jpg";